module.exports = __webpack_public_path__ + "cement/img/蒙版组 71@2x.856c15ea.png";